import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import { styled } from "@mui/material/styles";
import Skeleton from "@mui/material/Skeleton";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
const BlockWrapper = styled(Box)(({
  theme
}) => ({
  display: "flex",
  flexDirection: "row",
  borderRadius: theme.sizes.radius.lg,
  overflow: "hidden",
  backgroundColor: "rgba(255, 179, 129, 1)"
}));
const ImageWrapper = styled(Box)(() => ({
  flex: "0 0 auto",
  width: 319,
  height: 272,
  objectFit: "cover",
  mixBlendMode: "multiply",
  backgroundColor: "rgba(255, 179, 129, 1)"
}));
const ContentWrapper = styled(Box)(({
  theme
}) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.sizes.spacing["09"],
  justifyContent: "space-between",
  alignItems: "flex-start",
  padding: theme.sizes.spacing["09"],
  backgroundSize: "cover",
  background: "linear-gradient(to right, #131210 0%, #D7591B 100%)",
  flexGrow: 1
}));
const HeadingWrapper = styled(Box)(({
  theme
}) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.sizes.spacing["07"],
  alignItems: "flex-start",
  alignSelf: "flex-start"
}));
const Banner = (t0) => {
  const $ = c(18);
  const {
    header,
    subtitle,
    image,
    cta,
    isLoading: t1
  } = t0;
  const isLoading = t1 === void 0 ? false : t1;
  if (isLoading) {
    let t22;
    if ($[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel")) {
      t22 = /* @__PURE__ */ jsx(Skeleton, { variant: "text", width: 350, height: 80 });
      $[0] = t22;
    } else {
      t22 = $[0];
    }
    return t22;
  }
  let t2;
  if ($[1] !== image) {
    t2 = image && /* @__PURE__ */ jsx(ImageWrapper, { children: /* @__PURE__ */ jsx(image.component, { src: image.src, alt: image.alt, width: 319, height: 272 }) });
    $[1] = image;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== header) {
    t3 = header && /* @__PURE__ */ jsx(Typography, { variant: "h1", sx: {
      color: "white",
      width: "24rem"
    }, children: header });
    $[3] = header;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== subtitle) {
    t4 = subtitle && /* @__PURE__ */ jsx(Typography, { variant: "body1", sx: {
      color: "#C4C3C2"
    }, children: subtitle });
    $[5] = subtitle;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = /* @__PURE__ */ jsxs(HeadingWrapper, { children: [
      t3,
      t4
    ] });
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== cta) {
    t6 = cta && /* @__PURE__ */ jsx(cta.component, { onClick: () => cta.onNavigate ? cta.onNavigate(cta.url) : window.open(cta.url, "_self"), children: cta.label });
    $[10] = cta;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = /* @__PURE__ */ jsxs(ContentWrapper, { children: [
      t5,
      t6
    ] });
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t2 || $[16] !== t7) {
    t8 = /* @__PURE__ */ jsx(BlockWrapper, { children: /* @__PURE__ */ jsxs(Fragment, { children: [
      t2,
      t7
    ] }) });
    $[15] = t2;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
};
export {
  Banner as default
};
